<template>
	<div id="projectView">
		<section class="post pb-0">
			<header class="major">
				<h2>Unsere Herzens Projekte</h2>
			</header>
		</section>
	<RTProject/>
  </div>
</template>

<script>
import RTProject from '@/components/RTProject.vue'
import {helper} from '@/mixins/helper.js'
  export default {
	name: 'ProjectsView',
	mixins:[helper],
    components: {
		RTProject
  },
  computed:{
  },
  methods:{
	getMaxWidthOfPlayer(){
		return this.isSmallTouchDevice()?300:640;
	},
	getHeightOfPlayer(){
		return this.isSmallTouchDevice()?200:360;
	}
  },
  }
</script>

<style scoped>

</style>
